var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcFlask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.989 17.9419L15.2338 7.215V3.46875H16.7338V1.5H7.26509V3.46875H8.76509V7.215L2.00994 17.9419C1.40056 18.9094 1.31713 19.9917 1.86931 20.9934C2.4215 21.9952 3.35525 22.5 4.49947 22.5H19.4995C20.6437 22.5 21.577 21.9956 22.1292 20.9934C22.6813 19.9912 22.5998 18.9094 21.989 17.9419ZM10.5178 8.12766C10.6598 7.90336 10.735 7.64317 10.7343 7.37766V3.46875H13.2656V7.43391C13.2655 7.66324 13.3305 7.88788 13.4531 8.08172L16.7254 13.2656H7.27353L10.5178 8.12766Z",
    fill: "#00EEFA",
    fillOpacity: 0.85
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFlask);
export default __webpack_public_path__ + "static/media/ic-flask.bcb585d6.svg";
export { ForwardRef as ReactComponent };